import AccordionRenderer from './components/AccordionRenderer';
import BodyDefaultRenderer from './components/BodyRenderer';
import ItemDefaultRenderer from './components/ItemRenderer';
//components
import SectionDefaultRenderer from './components/SectionRenderer';
//types
import { AccordionComponentProps } from './types';

const AccordionComponent: React.FC<AccordionComponentProps> = ({
  Accordion,
  SectionRenderer,
  BodyRenderer,
  ItemRenderer,
  accordionProps,
  rendererProps,
  contents,
  onClick,
  onAccordionChange,
}) => {
  const Section = SectionRenderer ?? SectionDefaultRenderer;
  const Body = BodyRenderer ?? BodyDefaultRenderer;
  const Item = ItemRenderer ?? ItemDefaultRenderer;
  const contentSize = contents ? contents.length - 1 : 0;

  return (
    <>
      {contents.map((section, index) => (
        <AccordionRenderer
          key={section.id}
          Accordion={Accordion}
          BodyRenderer={Body}
          ItemRenderer={Item}
          SectionRenderer={Section}
          accordionProps={accordionProps}
          contentSize={contentSize}
          index={index}
          rendererProps={rendererProps}
          section={section}
          showExpandIcon={!SectionRenderer}
          onAccordionChange={onAccordionChange}
          onClick={onClick}
        />
      ))}
    </>
  );
};

export default AccordionComponent;
export * from './types';
